import { HTMLAttributes } from 'react';
import { cn } from 'shared/utils/cn';

type BadgeTone = 'accent' | 'neutral' | 'success' | 'warning' | 'danger';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  accent: 'bg-accent-soft text-primary-dark',
  neutral: 'bg-chip text-ink-secondary',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  danger: 'bg-danger-soft text-danger',
};

export function Badge({ tone = 'accent', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold',
        TONE_CLASSES[tone],
        className
      )}
      {...props}
    />
  );
}
